import { useGetFunctionalitiesQuery } from '@app/api/functionalitiesApi';
import { PageLoader } from '@app/components/PageLoader';
import { FINANCING_OPTIONS } from '@app/configs/financing';
const FunctionalityGuard = ({ requiredFunctionality, children }) => {
    var _a, _b, _c, _d, _e;
    const { data: functionalities, isLoading, isUninitialized } = useGetFunctionalitiesQuery();
    if (isLoading || isUninitialized) {
        return <PageLoader />;
    }
    const borrowingEnabled = (_a = functionalities === null || functionalities === void 0 ? void 0 : functionalities[FINANCING_OPTIONS.borrowing]) === null || _a === void 0 ? void 0 : _a.enabled;
    const investingEnabled = (_b = functionalities === null || functionalities === void 0 ? void 0 : functionalities[FINANCING_OPTIONS.investing]) === null || _b === void 0 ? void 0 : _b.enabled;
    const investorReadEnabled = (_c = functionalities === null || functionalities === void 0 ? void 0 : functionalities[FINANCING_OPTIONS.investor_read]) === null || _c === void 0 ? void 0 : _c.enabled;
    const borrowerReadEnabled = (_d = functionalities === null || functionalities === void 0 ? void 0 : functionalities[FINANCING_OPTIONS.borrower_read]) === null || _d === void 0 ? void 0 : _d.enabled;
    const routeFunctionalityEnabled = requiredFunctionality && ((_e = functionalities === null || functionalities === void 0 ? void 0 : functionalities[requiredFunctionality]) === null || _e === void 0 ? void 0 : _e.enabled);
    if ((!borrowingEnabled && !investingEnabled && !investorReadEnabled && !borrowerReadEnabled) ||
        (requiredFunctionality && !routeFunctionalityEnabled)) {
        window.location.replace(window.location.origin);
        return null;
    }
    return children;
};
export default FunctionalityGuard;
